__turbopack_context__.v({
  "submenuTrigger": "eRF_-a_submenuTrigger",
  "trigger": "eRF_-a_trigger",
});
